import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/global.css */
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-family: 'Inter', sans-serif;
    padding: 0;
    margin: 0;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-synthesis: none;
    -moz-font-feature-settings: 'kern';
    shape-rendering: geometricPrecision;
    direction: ltr;
    line-height: 100%;
    font-weight: 400;
    color: #fff;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }
  ul,
  li {
    list-style: none;
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb {
      background-color: var(--tab-bar-color);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
  /* .select_menu {
    position: relative;
    z-index: 2;
    margin: 0 0 0 10px;
  } */
  .select_menu .select-box {
    position: relative;
    display: block;
    font-size: 0.8rem;
    height: 30px;
    width: 130px;
    border-radius: 5px;
  }

  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/user-account.css */
  .content {
    width: 100%;
    align-items: flex-start;
    border-top: 1px solid var(--tab-bar-border);
    padding: 30px 0 0 0;
    overflow: visible;
  }
  .content.column {
    width: 100%;
    align-items: center;
    padding: 30px 0 0 0;
    border-top: 0;
  }
  .subtitle {
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    margin: 0 0 14px 30px;
  }
  .content.column .subtitle {
    margin: 0 0 14px 0;
    display: flex;
    align-items: center;
  }
  .grid-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .grid-content label {
    padding: 0 0 10px 0;
    line-height: 130%;
    display: flex;
    align-items: center;
  }
  .grid-content label.title {
    text-align: right;
    text-transform: uppercase;
    font-size: 0.8rem;
    justify-content: flex-end;
    /* max-width: 160px; */
  }
  .grid-content.prefs label.title,
  .grid-content.email label.title {
    text-transform: none;
  }
  .grid-content label.value {
    margin: 0 0 0 15px;
    font-weight: 700;
    font-size: 0.8rem;
    justify-content: flex-start;
  }
  .grid-content.prefs label.title:last-child,
  .grid-content.prefs label.value:last-child {
    padding-bottom: 0 !important;
  }
  .select_menu {
    margin: 0;
  }
  .select_menu .select-box__option {
    display: block;
    padding: 10px 15px;
    background: hsla(218, 23%, 15%, 0.7);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
  }
  .select_menu .select-box__input-text {
    background: hsl(218, 23%, 10%);
    width: 110px;
  }
  .select_menu .select-box {
    width: 110px;
  }
  .select_menu .select-box__current {
    width: 110px;
  }
  .select_menu .select-box__list {
    width: 110px;
  }
  #user-prefs_tab_two:checked ~ .user_panels #user-prefs_panel {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    overflow-y: auto;
    max-height: 350px;
    min-height: 350px;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/wallet.css */
  .wallet_tabs_panel {
    display: none;
    width: 100%;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (max-width: 430px) {
    #game_main_area .menu_select {
      width: 14px;
      height: 14px;
      background: hsla(0, 0%, 0%, 0.2) url(${icons.arrow_up}) center 2px / auto
        9px no-repeat;
    }
  }
  /*! CSS Used keyframes */
  @keyframes HideList {
    from {
      transform: scaleY(1);
    }
    to {
      transform: scaleY(0);
    }
  }
  @keyframes HideList {
    from {
      transform: scaleY(1);
    }
    to {
      transform: scaleY(0);
    }
  }
`

const developerCSS = css``

export const UserPreferencesCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
